<template>
  <div class="page-container" v-wechat-title="myTitle">
    <!-- 顶部状态栏占位 -->
    <div class="status-bar-placeholder"></div>
    
    <main class="main-content">
      
      <!-- 1. 顶部导航栏 -->
      <div class="nav-header">
        <div class="page-title">{{ title }}</div>
        <van-icon name="plus" class="add-btn" @click="showAddSelect=true"></van-icon>
      </div>

      <!-- 2. 空状态提示 -->
      <div v-if="!loadingPage && data.list.length <= 0" class="empty-state">
        <div v-if="data.isHaveUserInfo && data.isChecking" class="empty-text">
          资质正在检测中<br>请稍后查看
        </div>
        <div v-if="data.isHaveUserInfo && !data.isChecking" class="empty-text clickable" @click="onCheckName">
          未能检测到您的资质<br>请检查您的生日和英文（拼音）姓名是否正确
          <br><span class="link-text">点击修改信息</span>
        </div>
        <div v-if="!data.isHaveUserInfo" class="empty-text clickable" @click="onCheckName">
          <van-icon name="add-o" size="40" color="#9CA3AF" /><br>
          请先填写用户信息<br>以便我们核实您的潜水员资质
        </div>
      </div>

      <!-- 3. 证书列表 -->
      <div 
        v-for="item in data.list" 
        :key="item.certificationId" 
        class="cert-card"
        @click="onSelectCard(item)"
      >
        <div class="cert-visual">
          <div class="org-badge">{{ item.groupTeam === 'OTHER' ? item.groupTeamName : item.groupTeam }}</div>
          <img 
            :src="item.image ? item.image : '/img/defaultcertificate.jpg'" 
            class="cert-img" 
            alt="Certificate"
          />
        </div>
        
        <div class="cert-body">
          <div class="cert-header">
            <h2 class="cert-name">{{ item.cerificateName }}</h2>
            <div class="cert-date">
              <svg viewBox="0 0 1024 1024" width="14" height="14" fill="currentColor" style="margin-right: 4px; opacity: 0.7;">
                <path d="M832 64h-64V32c0-17.674-14.326-32-32-32s-32 14.326-32 32v32h-384V32c0-17.674-14.326-32-32-32s-32 14.326-32 32v32h-64C137.6 64 96 105.6 96 156.8v710.4C96 918.4 137.6 960 192 960h640c54.4 0 96-41.6 96-92.8V156.8C928 105.6 886.4 64 832 64z m32 803.2c0 17.6-14.4 32-32 32H192c-17.6 0-32-14.4-32-32V320h704v547.2z" />
              </svg>
              颁发日期：{{ item.certificateDate ? formatDate(item.certificateDate, "yyyy/MM/dd") : '-' }}
            </div>
          </div>

          <div class="detail-grid">
            <div class="info-item">
              <span class="info-label">证书编号</span>
              <span class="info-value">{{ item.cerificateId }}</span>
            </div>
            
            <div class="info-row-group">
              <div class="info-item">
                <span class="info-label">认证教练</span>
                <span class="info-value">{{ item.instructorName ? item.instructorName : (item.instructorID || '-') }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">潜水中心</span>
                <span class="info-value">{{ item.divecenterName ? item.divecenterName : (item.divecenterID || '-') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </main>

    <!-- 4. 底部导航栏 -->
    <!-- <van-tabbar v-model="activeTab" active-color="#0057FF" inactive-color="#9CA3AF" fixed placeholder>
      <van-tabbar-item icon="shop-o" @click="onTabClick('dive')">潜水</van-tabbar-item>
      <van-tabbar-item icon="description" @click="onTabClick('cert')">证书</van-tabbar-item>
      <van-tabbar-item icon="manager" @click="onTabClick('my')">我的</van-tabbar-item>
    </van-tabbar> -->

    <!-- 5. 隐藏功能组件 -->
    <van-popup v-model="showAddSelect" position="bottom">
      <van-picker
        title="添加证书方式"
        show-toolbar
        :columns="addType"
        @confirm="onConfirmAdd"
        @cancel="showAddSelect=false"
      />
    </van-popup>

    <addCodeImgCert v-model="showAidaCertAdd" />
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
    <certificateDialog v-model="showCertificate" @finish="onCertificateFinish" />
    <NativeBar ref="menu" v-model="NativeBarId" />
  </div>
</template>

<script>
import request from '@/utils/request'
import { Button, Step, Steps, Dialog, Toast, Skeleton, NoticeBar, Picker, Popup, Icon, Tabbar, TabbarItem } from 'vant'
import { getUrlKey, formatDate, MyNotify } from '@/utils/base'
import { GetSysTitle } from '@/utils/base'
import wxShare from '@/components/wxShare'
import { GetSelfUrl } from '@/utils/request'
import commonData from '@/commondata.js'
import addCodeImgCert from '@/components/addCodeImgCert'
import certificateDialog from '@/components/certificateDialog'
import NativeBar from '@/components/NativeBar'

export default {
  name: 'MyCertificate',
  components: {
    [Button.name]: Button,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    [Skeleton.name]: Skeleton,
    [NoticeBar.name]: NoticeBar,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    wxShare,
    addCodeImgCert,
    certificateDialog,
    NativeBar
  },
  data() {
    return {
      NativeBarId: 'cert',
      activeTab: 1, 
      myTitle: '',
      title: '我的证书',
      backurl: '/my/index',
      data: {
        list: [],
        isHaveUserInfo: false,
        isChecking: false
      },
      loadingPage: true,
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: '',
      showAddSelect: false,
      addType: ['检查姓名生日', '刷新证书', '通过AIDA证书编号'],
      showAidaCertAdd: false,
      showCertificate: false
    }
  },
  activated() {
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'cert'
    }, 1)
  },
  created() {
    this.myTitle = GetSysTitle()
    this.init(()=>{
      this.myTitle = GetSysTitle()
    })
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'cert'
    }, 1)
  },
  methods: {
    formatDate,
    GetSysTitle,
    init(callback) {
      request({
        url: '/user/getUserCertificate',
        method: 'post'
      }).then(response => {
        this.loadingPage = false
        if(callback){
          callback();
        }
        if (!response.success) {
          return
        }
        this.data = response.data
        this.shareTitle = '我在' + this.data.totalGroupNum + '家机构有' + this.data.totalNum + '张潜水资质证书，你呢?'
        this.shareAbout = '免费查询多家机构潜水资质证书，潜水员双11更有商品专享优惠，快来看看。'
        this.shareTimeline = '我在' + this.data.totalGroupNum + '家机构有' + this.data.totalNum + '张潜水资质证书，你呢?'
        this.shareUrl = GetSelfUrl() + 'my/myCerificate?system=' + commonData.systemBase
        this.shareIcon = GetSelfUrl() + 'img/store.jpg'
      })
    },
    onSelectCard(data) {
      if (data.hashCode) {
        this.$router.push('/c/' + data.hashCode)
      } else {
        Toast.loading({
          message: '初始化中...',
          duration: 0,
          forbidClick: true,
          loadingType: 'spinner'
        })
        this.createVirtualCertificate(data, () => {
          Toast.clear(true)
          this.$router.push('/c/' + data.hashCode)
        })
      }
    },
    createVirtualCertificate(data, callback) {
      request({
        url: '/user/creatreVirtualCertificate',
        method: 'post',
        params: { id: data.userCertificateId }
      }).then(response => {
        if (!response.success) {
          return
        }
        data.hashCode = response.data
        if (callback) {
          callback()
        }
      })
    },
    onCheckName() {
      this.showAddSelect = true
    },
    onConfirmAdd(value, index) {
      this.showAddSelect = false
      switch (value) {
        case '检查姓名生日':
          this.$router.push('/my/updateNameBirthday')
          break
        case '刷新证书':
          this.onReloadCertiticate()
          break
        case '通过AIDA证书编号':
          this.showAidaCertAdd = true
          break
      }
    },
    onReloadCertiticate() {
      Dialog.confirm({
        title: '刷新资质',
        message: '如果您获得了新的潜水资质证书，可以刷新资质，刷新后请5分钟后来查看结果，如不能刷出您的潜水资质证书，请检查姓、名、生日、邮箱是否与申请时匹配'
      }).then(() => {
        this.onReloadCertiticateDo()
      })
    },
    onReloadCertiticateDo() {
      request({
        url: '/user/updateUserCertificate',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        MyNotify('success', '提交检测成功，请等待通知或者5分钟后来查看结果！')
      })
    },
    onShareFinish() {
      this.shareUrl = undefined
    },
    onCertificateFinish() {
      this.init()
    },
    onTabClick(type) {
      if (type === 'dive') {
        // 占位
      } else if (type === 'my') {
        this.$router.push('/my/index')
      }
    }
  }
}
</script>

<style scoped>
/* --- 全局样式 --- */
.page-container { 
  min-height: 100vh; 
  background-color: #F9FAFB; 
  padding-bottom: 80px; 
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, sans-serif;
  color: #374151;
}

.status-bar-placeholder { height: 20px; }
.main-content { padding: 16px; max-width: 480px; margin: 0 auto; }

/* --- 顶部导航栏 --- */
.nav-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.page-title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
}
.add-btn {
  color: #0057FF;
  font-size: 24px;
  cursor: pointer;
}

/* --- 空状态 --- */
.empty-state {
  text-align: center;
  margin-top: 10vh;
  padding: 2rem;
  color: #9CA3AF;
  font-size: 14px;
  line-height: 1.6;
}
.empty-text { margin-bottom: 1rem; }
.clickable { cursor: pointer; }
.link-text { color: #0057FF; text-decoration: underline; }

/* --- 证书卡片样式 --- */
.cert-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.04);
  margin-bottom: 24px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  transition: transform 0.2s;
}
.cert-card:active { transform: scale(0.98); }

/* 核心：修复蓝线问题 */
.cert-visual {
  position: relative;
  width: 100%;
  aspect-ratio: 1.58 / 1;
  background-color: #003087; /* 深蓝背景 */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  
  /* 修复：确保垂直对齐，防止inline元素底部留白 */
  vertical-align: middle; 
  /* 修复：给下外边距 -1px，强制与下方白色区域重叠，消除亚像素缝隙 */
  margin-bottom: -1px;
  z-index: 1;
}

.cert-img {
  width: 100%;
  height: 100%;
  object-fit: contain; 
  display: block;
}

/* 组织Logo/标签 */
.org-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.9);
  color: #0057FF;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  z-index: 10;
}

/* --- 下半部分：信息详情区 --- */
.cert-body { 
  padding: 20px; 
  background-color: #fff; /* 明确背景色 */
  position: relative; 
  z-index: 2; /* 确保盖在深蓝背景溢出部分的上面 */
}

.cert-header {
  margin-bottom: 16px;
  border-bottom: 1px solid #F3F4F6;
  padding-bottom: 16px;
}
.cert-name {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 6px 0;
  line-height: 1.3;
}
.cert-date {
  font-size: 13px;
  color: #6B7280;
  display: flex;
  align-items: center;
  gap: 4px;
}

.detail-grid { display: grid; gap: 12px; }

.info-item { display: flex; flex-direction: column; gap: 2px; }
.info-label { font-size: 11px; color: #9CA3AF; }
/* 使用 DIN 字体优化数字显示 */
.info-value {
  font-size: 13px;
  color: #374151;
  font-weight: 500;
  word-break: break-all; 
  font-family: 'DIN Alternate', -apple-system, sans-serif; 
}

.info-row-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
</style>